<template>
  <div>
    <div class="container">
      <div class="handle-box">
        <el-select
          v-model="status"
          @change="handleSelectChange"
          class="handle-select mr10"
        >
          <el-option
            v-for="(child, index) in status_list"
            :key="index"
            :label="child.label"
            :value="child.value"
          ></el-option>
        </el-select>
        <el-input
          v-model="ip"
          placeholder="请输入IP"
          class="handle-input mr10"
        ></el-input>
        <el-button type="primary" icon="el-icon-search" @click="handleSearch"
          >搜索</el-button
        >
      </div>
      <el-table
        :data="tableData"
        border
        class="table"
        ref="multipleTable"
        header-cell-class-name="table-header"
        v-loading="loading"
      >
        <el-table-column prop="id" label="id" align="center"> </el-table-column>
        <el-table-column
          prop="country"
          label="国家"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="province"
          label="省份"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="city"
          label="城市"
          align="center"
        ></el-table-column>
        <el-table-column prop="ip" label="IP" align="center"></el-table-column>
        <el-table-column
          prop="created_at"
          label="创建时间"
          align="center"
        ></el-table-column>
        <el-table-column label="状态" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.status == 1">待封禁</span>
            <span v-else>已封禁</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200" align="center">
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.status == 1"
              type="text"
              @click="handleBlock(scope.row)"
              >拉黑</el-button
            >
            <el-button v-else type="text" @click="handleBlock(scope.row)"
              >解除拉黑</el-button
            >
            <el-button
              v-if="scope.row.phones != null"
              type="text"
              @click="handleCheckPhone(scope.row)"
              >查看手机号</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination" v-if="totalPages > 1">
        <el-pagination
          background
          layout="prev, pager, next"
          :current-page="currentPage"
          :page-size="page_size"
          :total="totalPages"
          @current-change="handlePageChange"
        ></el-pagination>
      </div>
    </div>
    <!-- 手机号列表 -->
    <el-dialog title="手机号列表" :visible.sync="checkPhoneDialog" width="30%">
      <el-table :data="checkPhoneTableData" border class="table">
        <el-table-column
          prop="phone_number"
          label="手机号"
          align="center"
        >
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import http from "../../../../api/smsApiConfig";
export default {
  name: "Msgblacklist",
  data() {
    return {
      tableData: [],
      checkPhoneTableData: [],
      status_list: [
        {
          label: "全部",
          value: "",
        },
        {
          label: "未封禁",
          value: "1",
        },
        {
          label: "已封禁",
          value: "2",
        },
      ],
      currentPage: 1,
      totalPages: 1,
      page_size: 10,
      pageTotal: 10,
      ip: "",
      loading: false,
      status: "",
      checkPhoneDialog: false,
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      let that = this;
      that.loading = true;
      let params = {
        page: that.currentPage,
        page_size: that.page_size,
        ip: that.ip != "" ? that.ip : "",
        status: that.status,
      };
      http.get("/admin/black_ip/list", { params: params }).then(function(res) {
        that.tableData = res.data.data.data;
        that.currentPage = parseInt(res.data.data.current_page);
        that.totalPages = res.data.data.total;
        that.pageTotal = that.totalPages * that.page_size;
        that.loading = false;
      });
    },
    handleSelectChange() {
      this.currentPage = 1;
      this.getData();
    },
    // 拉黑/解除拉黑
    handleBlock(row) {
      let that = this;
      let params = {
        ip: row.ip,
      };
      if (row.status == 2) {
        that
          .$confirm("确定要解除拉黑吗？", "提示", {
            type: "warning",
          })
          .then(() => {
            http.post("/admin/black_ip/status", params).then((res) => {
              if (res.data.status_code == 200) {
                that.$message.success(`解除拉黑成功`);
                that.getData();
              } else {
                that.$message.error(res.data.msg);
              }
            });
          })
          .catch(() => {});
      } else {
        that
          .$confirm("确定要拉黑吗？", "提示", {
            type: "warning",
          })
          .then(() => {
            http.post("/admin/black_ip/status", params).then((res) => {
              if (res.data.status_code == 200) {
                this.$message.success(`拉黑成功`);
                this.getData();
              } else {
                this.$message.error(res.data.msg);
              }
            });
          })
          .catch(() => {});
      }
    },
    // 查看手机号
    handleCheckPhone(row) {
      console.log(row, "row");
      let str = row.phones;
      let newArr = [];
      newArr = str.split(",").map((item) => ({ phone_number: item }));
      this.checkPhoneTableData = newArr;
      console.log(this.checkPhoneTableData, "1");
      this.checkPhoneDialog = true;
    },
    // 触发搜索按钮
    handleSearch() {
      this.currentPage = 1;
      this.getData();
    },
    handlePageChange(val) {
      this.currentPage = val;
      this.getData();
    },
  },
};
</script>

<style scoped>
.handle-box {
  margin-bottom: 20px;
}

.handle-select {
  width: 120px;
}

.handle-input {
  width: 300px;
  display: inline-block;
}
.table {
  width: 100%;
  font-size: 14px;
}
.red {
  color: #ff0000;
}
.mr10 {
  margin-right: 10px;
}
.table-td-thumb {
  display: block;
  margin: auto;
  width: 40px;
  height: 40px;
}
</style>
